"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CurrencyMenu;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function CurrencyMenu(_ref) {
  var currency = _ref.currency,
    onDelete = _ref.onDelete;
  var context = (0, _react.useContext)(_core.AppContext);
  var isUpdateGranted = (0, _react.useMemo)(function () {
    return context.isGrantedAny(['PCurrenciesUpdate', 'TCurrenciesUpdate']);
  }, [context]);
  var isDeleteGranted = (0, _react.useMemo)(function () {
    return context.isGrantedAny(['PCurrenciesDelete', 'TCurrenciesDelete']);
  }, [context]);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var onClickedOptions = function onClickedOptions(event) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  var onClickedClose = function onClickedClose() {
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    "aria-label": "options",
    color: "default",
    size: "small",
    onClick: onClickedOptions
  }, /*#__PURE__*/_react["default"].createElement(_commons.EllipsisIcon, null)), anchorEl && /*#__PURE__*/_react["default"].createElement(_material.Menu, {
    id: "currencies-item",
    anchorEl: anchorEl,
    keepMounted: true,
    onClose: onClickedClose,
    open: true,
    TransitionComponent: _material.Fade
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    component: _reactRouterDom.Link,
    to: context.fixPath("/currencies/".concat(currency.id, "/edit")),
    onClick: onClickedClose,
    disabled: !isUpdateGranted,
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.EditIcon, {
    fontSize: "small",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('buttons.edit'))), isDeleteGranted && /*#__PURE__*/_react["default"].createElement(_material.Divider, null), isDeleteGranted && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    onClick: function onClick() {
      return onDelete(currency);
    },
    dense: true
  }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_commons.DeleteIcon, {
    fontSize: "small",
    color: "error"
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "inherit"
  }, (0, _core.translate)('buttons.delete')))));
}